import moment from 'moment/moment';
import Commons from '../../helpers/Commons';

/*
* Get the default date range value per specific Tab
* dateJson is a json object contain the date range value and the option
* Sample dateJson value is {
*                               value: '20181112-20190212',
*                               option: '3months'
*                          }
* Sample return '12 Nov 2018 - 12 Feb 2019'
*/
const dateFilterInitialValue = (dateJson) => {
    let from = '';
    let to = '';
    if (typeof dateJson.value === 'string') {
        const { value } = dateJson;
        const valueArray = value && value.split('-');
        from = Commons.formatDate(valueArray[0].trim(), 'DD MMM YYYY');
        if (valueArray[1] && valueArray[0] !== '') {
            to = Commons.formatDate(valueArray[1].trim(), 'DD MMM YYYY');
        } else {
            to = moment().format('DD MMM YYYY');
        }
    } else if (dateJson?.value?.min || dateJson?.value?.max) {
        from = Commons.formatDate(dateJson?.value?.min?.trim(), 'DD MMM YYYY');
        if (dateJson?.value?.max && dateJson?.value?.min !== '') {
            to = Commons.formatDate(dateJson?.value?.max?.trim(), 'DD MMM YYYY');
        } else {
            to = moment().format('DD MMM YYYY');
        }
    }
    return `${from} - ${to}`;
};


export default {
    dateFilterInitialValue,
};
